// firebase
import { db } from "config/firebase";
import { collection, query, getDocs, orderBy } from "firebase/firestore";

// A ---------------------------------------------------------------------- M

const fetchDataboxEvents = async (databoxID) => {
  try {
    const eventsRef = collection(db, "tagsdata", databoxID, "events");
    const q = query(eventsRef, orderBy("timestamp", "desc"));
    const querySnapshot = await getDocs(q);

    const events = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return events;
  } catch (error) {
    console.error("Error fetching events:", error);
    return [];
  }
};

export default fetchDataboxEvents;
